import React, { ReactElement, useState } from 'react';
import {
  Label,
  Link, Td, Tr,
} from 'idsk-react-components';
import routes from '../../../../../routing/routes';
import Dropdown from '../../../../Dropdown';
import PracovneKroky from '../../../LegislativnyMaterialDetail/component/PracovneKroky/PracovneKroky';
import mapDate from '../../../../../function/mapDate';
import './ulohyListTable.scss';
import LegislativnyMaterialUlohaItem
  from '../../../../../model/legislativnyMaterial/ulohy/LegislativnyMaterialUlohaItem';
import splitCisloLegMaterialu from '../../../../../function/splitCisloLegMaterialu';

interface Props {
  material: LegislativnyMaterialUlohaItem;
  reloadUlohyPage: () => void;
}

const UlohyListRow = ({
  material,
  reloadUlohyPage,
}: Props): ReactElement => {
  const [isDropdownOpened, setIsDropdownOpened] = useState<boolean>(false);

  const {
    type,
    year,
    index,
  } = splitCisloLegMaterialu(material?.cisloLp);

  return (
    <Tr key={material.uuid}>
      <Td>{material.cisloLp}</Td>
      <Td>
        <Link
          className="nazov-link"
          to={routes.procesy.detail.withParams(type, year, index)}
        >
          {material.nazov}
        </Link>
      </Td>
      <Td>{mapDate(material.datumPrijatia)}</Td>
      <Td>{mapDate(material.datumVybavenia)}</Td>
      <Td>{material.stadium.nazov}</Td>
      <Td>
        <Dropdown
          title="Pracovné kroky"
          isDropdownOpened={isDropdownOpened}
          setIsDropdownOpened={setIsDropdownOpened}
        >
          {material.pracovneKroky && material?.pracovneKroky.length > 0
            ? (
              <PracovneKroky
                legMaterial={{
                  typ: material.typ,
                  uuid: material.uuid,
                  cisloLegislativnehoMaterialu: material.cisloLp,
                }}
                pracovneKroky={{
                  pracovneKroky: material.pracovneKroky,
                }}
                reloadPracovneKroky={reloadUlohyPage}
                reloadDetail={reloadUlohyPage}
                ulohy
                setIsDropdownOpened={setIsDropdownOpened}
              />
            )
            : (
              <Label className="no-pracovny-krok__label">
                V aktuálnom stave procesu nemôžete vykonávať žiadne pracovné kroky.
              </Label>
            )}
        </Dropdown>
      </Td>
    </Tr>
  );
};

export default UlohyListRow;
